/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { addMappingGroup, getAccountGroups } from "../../apis/companies/account";
import ClientGroup from './ClientGroup';
import Form from '../Form';
import { isEmpty } from '../../utils/lodashExtend';
import { get } from 'lodash';

const ClientGroups = ({ cancel, cancelText, data }) => {

  const [open, setOpen] = useState(false);
  const [groups, setGroups] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const getFields = () => {
    const _fields = [
      [
        {
          title: "설정된 그룹",
          key: "groups",
          onValue: (v) => {
            return (v || []).map(item => item.name).join(', ');
          }
        },
      ],
      [
        {
          title: "그룹 선택",
          key: "group",
          type: "select",
          options: {
            list: () => {
              return groups.map(item => ({ label: item.name, value: item.idx + "" }));
            }
          },
          width: "60%"
        },
        {
          title: <></>,
          type: "button",
          color: "gray-line",
          label: "정보변경",
          action: () => {
            setSelectedItem({
              form,
              ...groups.find(f => f.idx + "" === form.group + ""),
            });
            setOpen(true);
          },
          width: "15%",
          labelWidth: 0,

        },
        {
          title: <></>,
          type: "button",
          label: "새로운 그룹 추가",
          action: () => {
            setOpen(true);
          },
          width: "25%",
          labelWidth: 0
        }
      ]


    ];
    return _fields;
  };

  const _submit = (form) => {
    if (!isEmpty(form.group) && +form.group > 0) {
      addMappingGroup({
        companyAccountIdx: data.idx,
        companyAccountGroupIdx: form.group
      })
        .then((res) => {
          cancel();
        })
        .catch((err) => console.error(err));
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
  } = useForm(
    {},
    _submit,
  );

  const getGroups = () => {
    if (!isEmpty(data)) {
      getAccountGroups({ order: [{ idx: "desc" }] })
        .then((res) => {
          const list = res.data?.rows || [];
          const groupList = list.filter(f =>
            !(data.companyAccountGroups || [])
              .find(ff => f.idx + "" === ff.idx + "")
          );
          const groups = !isEmpty(groupList) ? groupList : [{ name: "그룹을 생성해주세요!", idx: "-1" }];
          setGroups(groups);
          if (!isEmpty(data.companyAccountGroups)) {
            setForm({
              group: get(groups, "[0].idx") + "",
              groups: data.companyAccountGroups
            });
            setOriginForm({
              group: get(groups, "[0].idx") + "",
              groups: data.companyAccountGroups
            });
          } else {
            if (isEmpty(form?.group)) {
              !isEmpty(groups) && handleOnChange({ group: groups[0]?.idx + "" });
            }
          }
        })
        .catch((err) => {
          console.error(err.response);
        });
    }
  };

  useEffect(() => {
    getGroups();
  }, [data]);

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    setTimeout(() => {
      setFields(getFields());
    }, 10);
  }, [groups, form]);

  const isDisabledSubmit = useCallback(() => {
    return !(!isEmpty(form.group) && +form.group > 0);
  }, [form]);

  return (
    <>
      <Form
        form={form}
        errors={errors}
        isRequiredShow={true}
        setForm={setForm}
        fields={fields}
        onChange={handleOnChange}
        submitText={"그룹 설정"}
        submit={handleSubmit}
        cancel={cancel}
        cancelText={cancelText}
        isDisabledSubmit={isDisabledSubmit}
      />

      <ClientGroup
        open={open}
        setOpen={setOpen}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        submit={getGroups}
      />
    </>
  );
};

export default ClientGroups;